import React, { useCallback, useEffect } from "react"
import { get } from "lodash"
import { useSearchParams } from "react-router-dom"

import { useTheme, Box } from "@mui/material"
import _ from "lodash"

import { useVenue } from "providers/venue"
import { useGeoLocation } from "providers/geolocation"

import { OrdinalSelector } from "components/OrdinalSelector"
import { VenueSelector } from "components/VenueSelector"
import { FeatureChipToggleBar } from "../../../components/domains/features/ChipToggleBar"
import { PageCard } from "components/card"
import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"
import { useMap } from "hooks/map/useMap"
import { useFeatureCategory } from "hooks/feature/useFeatureCategory"
import { useHighLightFeaturesMap } from "hooks/feature/useHighLightFeaturesMap"

import { pushDataLayer } from "utils/googletagmanager"
import { GTM_AMENITY_SEARCH } from "constant"
import { SidebarMenu } from "components/navigation/SidebarMenu"
import { MapPageLayout } from "layouts/kiosk-h"
import { usePageSideBarLayout } from "providers/ui/hooks"

export const FeatureByCategoryKioskHPage = ({
  Layout = MapPageLayout,
  AppNavigation = DefaultAppNavigation,
}) => {
  const { venues, isMultiOrdinalVenue, isMultiVenueProject, dataLoaded } =
    useVenue()
  const { locationVenue, locationOrdinal } = useGeoLocation()
  const locationVenueId = get(locationVenue, "id")
  const [searchParams, setSearchParams] = useSearchParams()
  const { onChangeVenue } = useMap()

  const {
    viewingCategory,
    viewingVenueId,
    viewingOrdinal,
    comingFromOrdinal,
    featureCategories,
    searchableFeatures,
    quickSearchVenueLevels,
    handleClickQuickSearch,
  } = useFeatureCategory({
    initialVenueId: locationVenueId,
    initialOrdinal: locationOrdinal,
  })

  const theme = useTheme()
  const { styleOverrides = {} } = theme.components[`AppMap`] || {}
  const {
    searchBarContainer,
    quickLinkContainer, //TODO:: planning about quick search's working flow later
    venueSelector,
    ordinalSelectMenu,
    toolbarContainer,
  } = styleOverrides

  const enableMap =
    !_.isNil(viewingOrdinal) && _.isNil(comingFromOrdinal) && dataLoaded

  const onClickOrdinal = useCallback(
    (ordinal) => {
      const currentParams = Object.fromEntries(searchParams.entries())
      setSearchParams({ ...currentParams, ordinal })
    },
    [setSearchParams, searchParams]
  )

  //@ts-ignore
  useHighLightFeaturesMap(searchableFeatures, Number(viewingOrdinal), {
    enabled: enableMap,
  })

  useEffect(() => {
    if (viewingCategory) {
      pushDataLayer({
        event: GTM_AMENITY_SEARCH,
        amenity_category: viewingCategory,
      })
    }
  }, [viewingCategory])

  usePageSideBarLayout({
    sidebar: {
      open: false,
    },
  })

  return (
    //@ts-ignore
    <Layout
      aside={
        <PageCard>
          <SidebarMenu AppNavigation={AppNavigation} />
        </PageCard>
      }
    >
      <Box sx={toolbarContainer}>
        <Box sx={searchBarContainer}>
          {/* TODO: Find better solution for amenity quicksearch search drawer */}
        </Box>

        <Box sx={quickLinkContainer}>
          <FeatureChipToggleBar
            categories={featureCategories}
            onClick={handleClickQuickSearch}
          />
        </Box>
      </Box>
      {isMultiOrdinalVenue && (
        <Box sx={ordinalSelectMenu}>
          <OrdinalSelector
            selectedOrdinal={Number(viewingOrdinal)}
            levels={quickSearchVenueLevels}
            onClickOrdinal={onClickOrdinal}
            locationOrdinal={locationOrdinal}
            currentVenue={locationVenueId}
          />
        </Box>
      )}

      {isMultiVenueProject && (
        <Box sx={venueSelector}>
          <VenueSelector
            selectedVenue={viewingVenueId}
            venues={venues}
            onClickVenue={onChangeVenue}
            currentVenue={locationVenueId}
          />
        </Box>
      )}
    </Layout>
  )
}
